import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;

class EquipmentTypeService {
    getEquipmentType(url) {
        let ruta = `${API_URL}/equipment-type?url=${url}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
}

export default new EquipmentTypeService();
